import { format } from "date-fns";

export function formatSafeQuoteDate(
  value: number | string | Date | null | undefined,
  formatStr: string = "dd MMM yyyy"
): string {
  if (value == null) return "";
  try {
    let date: Date;
    if (typeof value === "number") {
      if (!Number.isFinite(value)) return "";
      date = new Date(value);
    } else if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed || trimmed === "NaN" || trimmed === "null" || trimmed === "undefined") return "";
      if (/^\d+$/.test(trimmed)) {
        date = new Date(Number(trimmed));
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
        const [y, m, d] = trimmed.split("-").map(Number);
        date = new Date(y, m - 1, d);
      } else {
        date = new Date(trimmed);
      }
    } else if (value instanceof Date) {
      date = value;
    } else {
      return "";
    }
    if (Number.isNaN(date.getTime())) return "";
    return format(date, formatStr);
  } catch {
    return "";
  }
}
